import tw from 'twin.macro';

export const StyledLabel = tw.span`
  capitalize font-bold text-[14px] leading-[1.125rem] tracking-tighter text-darkGray opacity-[0.49]
`;
